export type FormMenuComponentProps = {
    /** Identifikátory položek k zobrazení */
    formItemIds: ReadonlyArray<number>;
    /** Index zaměřené položky */
    focusedItemIndex: number | undefined;
    /** Nadpis sekce */
    title: string | undefined;
};
